import React, { type ForwardedRef, useImperativeHandle, useRef, useState } from 'react';

import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { useGetTaxpayer } from 'app/modules/taxes/hooks/useTaxes';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { notificationSuccess } from '../../../core/toast';
import { usePaginateApplication } from '../../../hooks';
import { useGetNonCompliancePaymentTaxpayer } from '../../NonCompliance/hooks';
import { ContainerPaymentsOmissions } from '../components/ContainerPaymentsOmissions';
import { NewCommunication } from '../components/NewCommunication';
import { TaxreturnsAndPayments } from '../components/TaxreturnsAndPayments';
import { useGetInfoCollectionTaxpayer } from '../hooks';
import { createCommunication } from '../http';
import { type Communication, type CreateCommunicationRequest } from '../types';

const ListCommunications = React.forwardRef(
  ({ search }: { search: any }, ref: ForwardedRef<any>) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(4);
    const [isReload, setIsReload] = useState(false);
    const [{ data: communications, loading: l1, error: e1 }, reload] =
      usePaginateApplication<Communication>(`TaxpayersComunications`, page, pageSize, search);

    useImperativeHandle(ref, () => ({
      refresh() {
        setIsReload(true);
        reload();
      }
    }));

    if ((l1 || e1) && !isReload) {
      return <></>;
    }
    return (
      <>
        {/* <Communications
          page={page}
          setPage={setPage}
          data={
            communications ?? {
              currentPage: page,
              pageSize,
              rowCount: 0,
              pageCount: 0,
              firstRowOnPage: 0,
              lastRowOnPage: 0,
              data: []
            }
          }
        /> */}
      </>
    );
  }
);

export const DetailNonCompliancePaymentsTaxpayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<Record<string, string>>();
  const listRef = useRef<any>(null);
  const [search, setSearch] = useState({ taxpayerId: id ?? '' });
  const { data, loading: l2, error: e2 } = useGetTaxpayer(id ?? '');
  const [{ data: omissions, loading: l3, error: e3 }] = useGetNonCompliancePaymentTaxpayer(
    id ?? ''
  );
  const [{ data: taxreturnsAndPayments, loading: l4, error: e4 }] = useGetInfoCollectionTaxpayer(
    id ?? ''
  );

  const onSubmit = async (request: CreateCommunicationRequest, close: () => void) => {
    await createCommunication(request);
    notificationSuccess(t('parameters-enviroments.messages.savedSucessfully'));
    close();
    //refresh();
    listRef.current?.refresh();
  };

  if (l2 || e2 || l3 || e3 || l3 || l4 || e4 || !data) {
    return <></>;
  }

  const labelTIN = t('config.tin');
  const title = t('collections.title.detailCollection');
  const labelTaxpayer = t('collections.label.taxpayer');
  const labelNonCompliances = t('non-compliances.title.nonCompliancesTax');
  const labelNewCommunication = t('collections.label.newCommunication');
  //titles
  const titleTaxreturnsAndPayments = t('collections.title.taxreturnAndPayments');
  const titleCommunications = t('collections.title.communications');

  return (
    <>
      <PageTitle title={title} />

      <div className="row">
        <div className="col-12 col-md-4">
          <div className="pair-name">{labelTIN}</div>
          <div className="pair-value"> {data.tin}</div>
        </div>
        <div className="col-12 col-md-8">
          <div className="pair-name">{labelTaxpayer}</div>
          <div className="pair-value"> {data.name}</div>
        </div>
      </div>
      <h1 className="mt-3">{labelNonCompliances}</h1>

      <ContainerPaymentsOmissions omissions={omissions ?? []} />
      <div className="row mt-4">
        <div className="col-12 col-lg-6">
          <PageTitle title={titleTaxreturnsAndPayments} />
          <div>
            <TaxreturnsAndPayments data={taxreturnsAndPayments ?? []} />
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <PageTitle title={titleCommunications} />
          <div>
            <ListCommunications ref={listRef} search={search} />
          </div>
        </div>
      </div>
      <NewCommunication onSubmit={onSubmit} taxpayerId={id ?? ''}>
        {(show: () => void) => {
          return (
            <>
              <BtnToolbar>
                {}
                <BtnGroup>
                  <Button
                    action={ButtonAction.return}
                    variant="secondary"
                    onClick={() => navigate('/collections/view-process')}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button
                    action={ButtonAction.new}
                    text={labelNewCommunication}
                    variant="primary"
                    onClick={() => show()}
                  />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </NewCommunication>

      {/*<BtnToolbar>*/}
      {/*  <BtnGroup>*/}
      {/*    <Button*/}
      {/*      action={ButtonAction.return}*/}
      {/*      variant="secondary"*/}
      {/*      onClick={() => navigate('/non-compliances/payments')}*/}
      {/*    />*/}
      {/*  </BtnGroup>*/}
      {/*  <BtnGroup>*/}
      {/*    <></>*/}
      {/*  </BtnGroup>*/}
      {/*</BtnToolbar>*/}
    </>
  );
};

ListCommunications.displayName = 'ListCommunications';
